import React from 'react'

import Box from 'components_new/atoms/Box'
import Chip from 'components_new/atoms/Chip'

import { IDashboardExample } from 'types/GlobalDashboardExample'
import { useTranslation } from 'language/translator'

interface TagsProps {
  dashboard: IDashboardExample
  sx?: object
}

const Tags = (props: TagsProps) => {
  const { dashboard, sx } = props
  const { lang } = useTranslation()

  const tags = [
    ...(dashboard.category.title ? [dashboard.category.title] : []),
    ...dashboard.segments.map((segment) => segment.title)
  ]

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 0.5,
          ...sx
        }}
      >
        {tags.map((tag) => (
          <Chip key={tag[lang]} label={tag[lang]} />
        ))}
      </Box>
    </>
  )
}

export default Tags
